'use strict';

var keyboardAccessibility = require('base/components/keyboardAccessibility');
var utils = require('../util/utils');
var debounce = require('lodash/debounce');
var $siteNav = $('.site-header');
var openMenuDelay;
var isMobile = utils.isMobile();
var delayTime = isMobile ? 0 : 200;

/**
 * Returns the visible category label from a menu link, excluding mobile chevrons.
 * @param {jQuery} $link - menu anchor element
 * @returns {string} trimmed category name
 */
var getLinkCategoryName = function ($link) {
    var $clone = $link.clone();
    $clone.find('.caret-icon, .d-lg-none').remove();
    return $.trim($clone.text());
};

/**
 * Prepends the mobile "[Category] Home" label to a cloned top-category link.
 * @param {jQuery} $link - cloned menu anchor element
 * @param {string} categoryName - parent category display name
 */
var setMobileShopCategoryLabel = function ($link, categoryName) {
    var pattern = $('.main-menu .navbar').data('mobileShopCategoryLabel') || '%category% Home';
    var label = pattern.replace('%category%', categoryName);

    $link.removeClass('dropdown-toggle has-sub-cat');
    $link.find('.caret-icon').remove();

    var updated = false;
    var contents = $link.contents().toArray();

    for (var i = 0; i < contents.length; i++) {
        var node = contents[i];

        if (node.nodeType === 3 && $.trim(node.nodeValue).length) {
            node.nodeValue = label;
            updated = true;
            break;
        }
    }

    if (!updated) {
        $link.prepend(document.createTextNode(label));
    }
};

/**
 * Moves checked callout items out of the callout and places them under the top-category link.
 * @param {jQuery} $topCategory - injected mobile top-category item
 */
var placeMobileTopCallouts = function ($topCategory) {
    var $anchor = $topCategory;

    $topCategory.parent().children('.dropdown-container').find('.visual-callout').children('.visual-callout__item--mobile-top')
        .each(function () {
            $anchor.after(this);
            $anchor = $(this);
        });
};

/**
 * Moves callout items back into the callout column.
 * @param {jQuery} $dropdownMenu - open dropdown menu
 */
var restoreMobileTopCallouts = function ($dropdownMenu) {
    var $callout = $dropdownMenu.find('.visual-callout').first();
    var $items = $dropdownMenu.children('.visual-callout__item--mobile-top');

    if ($callout.length && $items.length) {
        $items.appendTo($callout);
    }
};

var clearSelection = function (element) {
    var $element = $(element);
    var $menuContext = $element.closest('.dropdown, .dropdown-item');
    var $shownContext = $element.closest('.dropdown.show, .dropdown-item.show');
    var $closingTopCategory = $element.closest('li.top-category, li.nav-menu').not('.top-category--static');

    if ($closingTopCategory.parent().is('.dropdown-menu')) {
        restoreMobileTopCallouts($closingTopCategory.parent());
    }

    $menuContext
        .children('.dropdown-menu, .menu-list')
        .children('.top-category, .nav-menu')
        .not('.top-category--static')
        .detach();

    $shownContext.children('.nav-link, .dropdown-link').attr('aria-expanded', 'false');
    $shownContext.removeClass('show');

    $element.closest('li.top-category, li.nav-menu').not('.top-category--static').detach();
};

module.exports = function () {
    var siteId = $('.main-menu .navbar').data('siteId');
    var useSingleCloseButton = siteId === 'UA' || siteId === 'VETCOR';

    var isDesktopMenu = function (element) {
        return $(element).parents('.menu-toggleable-left').css('position') !== 'fixed';
    };

    var closeOtherTopLevelDropdowns = function (eventElement) {
        clearTimeout(openMenuDelay);
        $('.navbar-nav > li').each(function () {
            if (!$.contains(this, eventElement)) {
                $(this).removeClass('show');
                $(this).children('.dropdown-menu').removeClass('show');
                $(this).children('.nav-link').attr('aria-expanded', 'false');
                $(this).find('.dropdown-item.show').removeClass('show');
            }
        });
    };

    $('.menu-row').each(function () {
        var $row = $(this);
        var $firstColumn = $row.children('.brands-first-column');
        var $items = $row.children('.menu-list').children('.first-column-item');

        if (!isMobile && $items.length) {
            $items.clone().appendTo($firstColumn);
        } else {
            $firstColumn.remove();
        }
    });

    keyboardAccessibility('.main-menu .nav-link, .main-menu .dropdown-link',
        {
            40: function (menuItem) { // down
                if (menuItem.hasClass('nav-item')) { // top level
                    $('.navbar-nav .show').removeClass('show')
                        .children('.dropdown-menu')
                        .removeClass('show');
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    $(this).attr('aria-expanded', 'true');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                } else {
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.next().children().first().focus();
                }
            },
            39: function (menuItem) { // right
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.next().children().first().focus();
                } else if (menuItem.hasClass('dropdown')) {
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    $(this).attr('aria-expanded', 'true');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                }
            },
            38: function (menuItem) { // up
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                } else if (menuItem.prev().length === 0) {
                    menuItem.parent().parent().removeClass('show')
                        .children('.nav-link')
                        .attr('aria-expanded', 'false');
                    menuItem.parent().parent().children().first()
                        .focus();
                } else {
                    menuItem.prev().children().first().focus();
                }
            },
            37: function (menuItem) { // left
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.prev().children().first().focus();
                } else {
                    menuItem.closest('.show').removeClass('show')
                        .closest('li.show').removeClass('show')
                        .children()
                        .first()
                        .focus()
                        .attr('aria-expanded', 'false');
                }
            },
            27: function (menuItem) { // escape
                var parentMenu = menuItem.hasClass('show')
                    ? menuItem
                    : menuItem.closest('li.show');
                parentMenu.children('.show').removeClass('show');
                parentMenu.removeClass('show').children('.nav-link')
                    .attr('aria-expanded', 'false');
                parentMenu.children().first().focus();
            }
        },
            function () {
                return $(this).parent();
            }
        );

    $('.dropdown:not(.disabled) [data-toggle="sitenav"], a.has-sub-cat')
        .on('click', function (e) {
            if (!isDesktopMenu(this)) {
                e.preventDefault();
                e.stopPropagation();
                // copy parent element into current UL
                var isFirstLevelSubmenu = !$(this).hasClass('has-sub-cat');
                var isAccountMenu = $(this).parent().hasClass('account-item');
                var li = $('<li class="dropdown-item top-category"></li>');
                var link = $(this).clone()
                    .removeAttr('data-toggle')
                    .removeAttr('aria-expanded')
                    .attr('aria-haspopup', 'false');

                if (isFirstLevelSubmenu
                    && $(this).data('categoryId') !== 'students'
                    && useSingleCloseButton
                    && !isAccountMenu) {
                    setMobileShopCategoryLabel(link, getLinkCategoryName($(this)));
                } else {
                    link.removeClass('dropdown-toggle');
                }

                li.append(link);
                var useInlineBack = useSingleCloseButton;

                if (useInlineBack && !isAccountMenu) {
                    li.prepend($('.menu-back-source').first().clone().removeClass('d-none menu-back-source'));
                }

                var $submenu = $(this).hasClass('has-sub-cat')
                    ? $(this).closest('.dropdown-item').find('> .menu-list')
                    : $(this).parent().children('.dropdown-menu');

                if (!isAccountMenu) {
                    $submenu.prepend(li);
                }

                if (!useInlineBack) {
                    var closeMenu = $('<li class="nav-menu mb-0"></li>');
                    closeMenu.append($('.close-menu').first().clone());
                    $submenu.prepend(closeMenu);
                }

                if (isFirstLevelSubmenu && !isAccountMenu) {
                    placeMobileTopCallouts(li);
                }

                if ($(this).hasClass('has-sub-cat')) {
                    // copy navigation menu into view
                    $(this).closest('.dropdown-item').addClass('show');
                } else {
                    // copy navigation menu into view
                    $(this).parent().addClass('show');
                }
                $(this).attr('aria-expanded', 'true');
                e.stopImmediatePropagation();
            }

            // Add support for expandable navigation to work on tablet landscape on click
            if (isMobile) {
                e.preventDefault();
            }
        })
        .on('mouseenter', function () {
            if (isDesktopMenu(this)) {
                closeOtherTopLevelDropdowns(this);

                openMenuDelay = setTimeout(() => {
                    $(this).parent().addClass('show');
                    $(this).siblings('.dropdown-menu').addClass('show');
                    $(this).attr('aria-expanded', 'true');
                }, delayTime);
            }
        })
        .parent()
        .on('mouseleave', function () {
            if (isDesktopMenu(this)) {
                $(this).removeClass('show');
                $(this).children('.dropdown-menu').removeClass('show');
                $(this).children('.nav-link').attr('aria-expanded', 'false');
                clearTimeout(openMenuDelay);
            }
        });

    $('.navbar-nav > li.nav-item:not(.dropdown) > .nav-link')
        .on('mouseenter', function () {
            if (isDesktopMenu(this)) {
                closeOtherTopLevelDropdowns(this);
            }
        });


    /**
     * Returns the mobile menu to the root category list.
     */
    function resetMobileMenu() {
        $('.navbar-nav .dropdown-menu').each(function () {
            restoreMobileTopCallouts($(this));
        });
        $('.navbar-nav').find('.top-category').not('.top-category--static').detach();
        $('.navbar-nav').find('.nav-menu').detach();
        $('.menu-row > .menu-list > .dropdown-item.show > .menu-list').removeClass('slide-out');
        $('.navbar-nav').find('.show').removeClass('show');
        $('.navbar-nav').find('[aria-expanded="true"]').attr('aria-expanded', 'false');
    }

    /**
     * Closes the side bar navigation menu
     * @param {Object} e - This passes in the event jQuery event
     */
    function menuClose(e) {
        e.preventDefault();
        if (useSingleCloseButton) {
            $('.menu-row > .menu-list > .dropdown-item.show > .menu-list').addClass('slide-out');
        }
        $('.menu-toggleable-left').addClass('out');
        $('.menu-toggleable-left').removeClass('in');
        setTimeout(function () {
            $('body').removeClass('overflow-hidden');
            if (useSingleCloseButton) {
                resetMobileMenu();
            }
        }, 450);

        if (document.body.getBoundingClientRect().top <= -102) {
            $siteNav.addClass('is-stuck animation-none');
        }
    }

    $('.navbar > .close-button, .navbar > .close-menu .close-button').on('click', function (e) {
        menuClose(e);
    });

    $('.navbar-nav').on('click', '.back', function (e) {
        e.preventDefault();
        clearSelection(this);
    });

    $('.navbar-nav').on('click', '.close-button', function (e) {
        e.preventDefault();
        if (!useSingleCloseButton) {
            $('.menu-row > .menu-list > .dropdown-item.show > .menu-list').addClass('slide-out');
            setTimeout(function () {
                $('.navbar-nav').find('.top-category').not('.top-category--static').detach();
                $('.navbar-nav').find('.nav-menu').detach();
                $('.menu-row > .menu-list > .dropdown-item.show > .menu-list').removeClass('slide-out');
                $('.navbar-nav').find('.show').removeClass('show');
            }, 450);
        }
        $('.navbar > .close-button, .navbar > .close-menu .close-button').first().trigger('click');
    });

    // hamburger menu
    $('.navbar-toggler').on('click', function (e) {
        e.preventDefault();
        $('.main-menu').removeClass('out');
        $('.main-menu').addClass('in');
        $('body').addClass('overflow-hidden');

        if ($siteNav.hasClass('is-stuck')) {
            $siteNav.removeClass('is-stuck');
        }
        $('#expandableSearch').attr('aria-expanded', 'false');
    });

    keyboardAccessibility('.navbar-header .user',
        {
            40: function ($popover) { // down
                if ($popover.children('a').first().is(':focus')) {
                    $popover.children('a').first().next().focus();
                } else {
                    $popover.children('a').first().focus();
                }
            },
            38: function ($popover) { // up
                if ($popover.children('a').first().is(':focus')) {
                    $(this).focus();
                    $popover.removeClass('show');
                } else {
                    $popover.children('a').first().focus();
                }
            },
            27: function ($popover) { // escape
                $(this).focus();
                $popover.removeClass('show');
            },
            9: function ($popover) { // tab
                $popover.removeClass('show');
            }
        },
        function () {
            var $popover = $('.user .popover');
            if (!($popover.hasClass('show'))) {
                $popover.addClass('show');
            }
            return $popover;
        }
    );

    $('.navbar-header .user').on('mouseenter focusin', function () {
        if ($('.navbar-header .user .popover').length > 0) {
            $('.navbar-header .user .popover').addClass('show');
        }
    });

    $('.navbar-header .user').on('mouseleave', function () {
        $('.navbar-header .user .popover').removeClass('show');
    });

    if (isMobile) {
        $(window).on('resize', debounce(function () {
            // If mobile menu is open and window resized beyon tablet portrait, close it.
            if ($('.main-menu').hasClass('in') && window.matchMedia('(min-width: 992px)').matches) {
                if ($('.main-menu').find('.show').last().length) {
                    $('.main-menu .close-button').last().trigger('click');
                } else {
                    $('.main-menu .close-button').first().trigger('click');
                }
            }

            // If Desktop nav is open and screen changed to tablet potrait, close it.
            if ($('.nav-item').hasClass('show') && (window.matchMedia('(min-width: 768px)').matches && window.matchMedia('(orientation: portrait)').matches)) {
                var $activeNav = $('.nav-item.show');
                $activeNav.removeClass('show').children('.dropdown-menu').removeClass('show');
                $activeNav.children('.nav-link').attr('aria-expanded', 'false');
            }
        }, 250));
    }

    if ($('.first-on-mobile')) {
        $('.first-on-mobile').parent().addClass('has-mobile-first');
    }
};
